module.exports = __webpack_public_path__ + "img/More.2d478f5b.svg";